import { BadgePill } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { BoundingBox } from './types';

interface FaceOverlayContainerProps {
  $boundingBox: BoundingBox;
}

const FaceOverlayContainer = styled.div<FaceOverlayContainerProps>`
  position: absolute;
  left: ${({ $boundingBox }): number => $boundingBox.left * 100}%;
  top: ${({ $boundingBox }): number => $boundingBox.top * 100}%;
  width: ${({ $boundingBox }): number => $boundingBox.width * 100}%;
  height: ${({ $boundingBox }): number => $boundingBox.height * 100}%;
  pointer-events: auto;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;

  &.visible {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

const FaceOverlaySquare = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
`;

const FaceOverlayLabel = styled.div`
  position: absolute;
  bottom: -32px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`;

export interface FaceOverlayProps {
  personName: string;
  boundingBox: BoundingBox;
  isVisible: boolean;
  onHover: () => void;
  onLeave: () => void;
}

export const FaceOverlay: FunctionComponent<FaceOverlayProps> = ({
  personName,
  boundingBox,
  isVisible,
  onHover,
  onLeave
}) => (
  <FaceOverlayContainer
    $boundingBox={boundingBox}
    className={isVisible ? 'visible' : ''}
    data-testid="person-face-overlay"
    onMouseEnter={onHover}
    onMouseLeave={onLeave}
  >
    <FaceOverlaySquare data-testid="person-face-overlay-square" />
    <FaceOverlayLabel>
      <BadgePill
        backgroundColor="#EBECF0"
        borderColor="#EBECF0"
        element="span"
        ellipsis
        fontColor="#4E5363"
        fontSize={12}
        radius={2}
      >
        {personName}
      </BadgePill>
    </FaceOverlayLabel>
  </FaceOverlayContainer>
);
